import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoadingSpinner } from '~/components/LoadingSpinner';
import { TurnstileGate } from '~/components/TurnstileGate';
import { PublicLayout } from '~/layouts/PublicLayout';

const LazyCN01FormPage = lazy(async () => {
  const mod = await import('~/pages/cn01');
  return { default: mod.CN01FormPage };
});

const LazyCN01PrintPage = lazy(async () => {
  const mod = await import('~/pages/cn01/print/Cn01PrintPage');
  return { default: mod.Cn01PrintPage };
});

const LazySupplierFormPage = lazy(async () => {
  const mod = await import('~/pages/supplier');
  return { default: mod.SupplierFormPage };
});

export function PublicRoutes() {
  return (
    <Routes>
      <Route
        path="/cn01-form"
        element={
          <PublicLayout>
            <TurnstileGate action="cn01-form">
              <Suspense fallback={<LoadingSpinner />}>
                <LazyCN01FormPage />
              </Suspense>
            </TurnstileGate>
          </PublicLayout>
        }
      />
      <Route
        path="/cn01-print/:cn01FormId"
        element={
          <PublicLayout>
            <TurnstileGate action="cn01-print">
              <Suspense fallback={<LoadingSpinner />}>
                <LazyCN01PrintPage />
              </Suspense>
            </TurnstileGate>
          </PublicLayout>
        }
      />
      <Route
        path="/supplier-form"
        element={
          <PublicLayout>
            <TurnstileGate action="supplier-form">
              <Suspense fallback={<LoadingSpinner />}>
                <LazySupplierFormPage />
              </Suspense>
            </TurnstileGate>
          </PublicLayout>
        }
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
